<template>
  <v-card outlined color="background">
    <v-card-text>
      <v-col>
        <v-row justify="center" style="font-size: 16px">
          <b> {{ $t('From: ') }}  </b>  {{ getFrom(this.$user) }}
        </v-row>
        <v-row justify="center" style="font-size: 16px">
          <b>{{ $t('To:') }}</b> {{ getTo(this.$user) }}
        </v-row>
        <v-icon style="position:absolute;right:10px;top:5px;" size="30px">
          mdi-file-download-outline
        </v-icon>
      </v-col>
      <v-row justify="center">
        <v-card width="200px" style="margin-bottom: 15px">
          <v-card-subtitle align="center">
            <span style="font-size: 18px"><b>{{ invoice.number }}</b></span>
          </v-card-subtitle>
          <v-card-text align="center">
            <span style="font-size: 20px; color: #43E1B2"><b>{{ invoice.amount }} €</b></span>
          </v-card-text>
        </v-card>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Constants from "../../../constants";

export default {
    name: 'SmallInvoice',
    props: {
        invoice: {
            type: Object,
            default: null
        },
        userProp: {
            type: Object,
            default: null
        },
        full: {
            type: Boolean,
            default: false
        },
        progress: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        textProgress: "",
        user: null,
    }),
    created () {
        if (this.userProp) this.user = this.userProp;
        else this.user = this.$user;
    },
    methods: {
        calculateProgressText () {
            if (this.invoice.status === Constants.INVOICE.STATUS_COMPENSATED) {
                return this.$t('Compensated');
            } else {
                switch (this.invoice.payment) {
                case Constants.INVOICE.PAYMENT_PENDING:
                    return this.$t('InvoiceStatus.Pending');
                case Constants.INVOICE.PAYMENT_SENT:
                    return this.$t('Sent');
                case Constants.INVOICE.PAYMENT_RECEIVED:
                    return this.$t('Received');
                }
            }
        },
        calculateProgressColor () {
            if (this.invoice.status === Constants.INVOICE.STATUS_COMPENSATED) {
                return "cyan";
            } else {
                switch (this.invoice.payment) {
                case Constants.INVOICE.PAYMENT_PENDING:
                    return "error";
                case Constants.INVOICE.PAYMENT_SENT:
                    return "warning";
                case Constants.INVOICE.PAYMENT_RECEIVED:
                    return "success";
                }
            }
        },
        calculateProgressValue () {
            if (this.invoice.status === Constants.INVOICE.STATUS_COMPENSATED) {
                return 100;
            } else {
                switch (this.invoice.payment) {
                case Constants.INVOICE.PAYMENT_PENDING:
                    return 33;
                case Constants.INVOICE.PAYMENT_SENT:
                    return 66;
                case Constants.INVOICE.PAYMENT_RECEIVED:
                    return 100;
                }
            }
        },
        iAmThePayer () {
            return this.user.cif === this.invoice.payer.cif;
        },
        iAmTheReceiver () {
            return this.user.cif === this.invoice.receiver.cif;
        },
        getIcon () {
            if (this.iAmThePayer()) {
                return "fa fa-file-export";
            } else if (this.iAmTheReceiver()) {
                return "fa fa-file-import";
            }
            return "fa fa-file-alt";
        },
        getFrom (register) {
            if (this.iAmThePayer() && register) {
                return this.$t('SmallInvoce.Me');
            }
            return this.invoice.payer.cif;
        },
        getTo (register) {
            if (this.iAmTheReceiver() && register) {
                return this.$t('SmallInvoce.Me');
            }
            return this.invoice.receiver.cif;
        }
    }
};
</script>

<style scoped>
  .v-card__text {
    padding: 10px;
  }
</style>

